//internal-deps
import React, { ReactElement } from "react";
import { memo } from "react";

import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// test ids
import { NOTES_WIDGET_TEST_IDS } from "@swiggy-private/payment-test-ids";

//styles
import { Container, ItemIcon, ListItems, NoteText } from "./styles";

function SwiggyMoneyNotes(props: { notes: string[]; title: string }): ReactElement | null {
    const { notes, title } = props;

    if (!notes.length) return null;
    return (
        <Container data-testid={NOTES_WIDGET_TEST_IDS.CONTAINER}>
            <Text data-testid={NOTES_WIDGET_TEST_IDS.TITLE} variant="V2.body3.neutral.medium" color="negative">
                {title}
            </Text>
            <ListItems data-testid={NOTES_WIDGET_TEST_IDS.ITEM_LIST}>
                {notes.map((text, i) => {
                    return (
                        <NoteText
                            data-testid={NOTES_WIDGET_TEST_IDS.CONTENT_ITEM}
                            variant="V2.body3.neutral.medium"
                            color="text_Low_Emphasis"
                            key={i}
                        >
                            <ItemIcon data-testid={NOTES_WIDGET_TEST_IDS.ICON} />
                            {text}
                        </NoteText>
                    );
                })}
            </ListItems>
        </Container>
    );
}

export default memo(SwiggyMoneyNotes);
